import { useGetMyAccount } from '@queries/Account'

import type { PermCodename } from '@type/permissions'

/**
 * UX-only permission check. The backend re-evaluates every
 * authorization decision via rbac.services.has_perm — this hook is
 * for hiding buttons and gating routes, not for actual security.
 *
 * Roles only answer "what actions can this user perform?" — workflow
 * visibility is enforced separately by the workflow ACL (Privacy
 * Settings on each workflow), which filters the workflows list on
 * the server. You do not need to (and cannot) check workflow scope
 * here.
 *
 * Returns false while /me is still loading (fail-closed), so guarded
 * UI does not flicker visible→hidden after the request resolves.
 */
export const useHasPermission = (codename: PermCodename): boolean => {
  const { data: user } = useGetMyAccount()
  if (!user) return false
  return (user.permissions ?? []).includes(codename)
}

export default useHasPermission
